import ApiService from "@/api";
import { get } from "lodash";
// initial state
const state = () => ({
    loading: false,
    list: [],
    post: {}
});

// getters
const getters = {};

// actions
const actions = {
    getBlogs(context) {
        const { commit, rootState } = context;
        commit("setLoading", true);
        let url = `/blog`;
        if (get(rootState, "app.lang") === "en") {
            url = `/en/blog`;
        }
        return new Promise(resolve => {
            ApiService.get(url)
                .then(({ data }) => {
                    commit("setLoading", false);
                    commit("setBlogs", data);
                    resolve(data);
                })
                .catch(() => {
                    commit("setLoading", false);
                });
        });
    },
    getPost({ commit }, postId) {
        commit("setLoading", true);
        return new Promise(resolve => {
            ApiService.get(`/get-articel/?postid=${postId}`)
                .then(({ data }) => {
                    commit("setLoading", false);
                    commit("setPost", data);
                    resolve(data);
                })
                .catch(() => {
                    commit("setLoading", false);
                });
        });
    }
};

// mutations
const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setBlogs(state, data) {
        state.list = data;
    },
    setPost(state, data) {
        state.post = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
